// extracted by mini-css-extract-plugin
export var bodySections = "_70-8";
export var gray = "_70-7";
export var green = "_70-4";
export var iconContainer = "_70-9";
export var iconWidgetContainer = "_70-1";
export var phoneIcon = "_70-2";
export var red = "_70-5";
export var statusDot = "_70-3";
export var widgetContainer = "_70-0";
export var yellow = "_70-6";